/* eslint-disable react/react-in-jsx-scope */
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAuthItem } from '../../CommonMethods/authSession';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const auth = useSelector(state => state?.auth);
    const { loggedIn } = auth;
    
    const isAuthenticated = loggedIn && getAuthItem('IdToken') !== null;

    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
